import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { HeadphonesOutlined } from '@landr/maestro';
import Styled from './CreatorLogo.styled';

export interface CreatorLogoProps {
    link?: string;
}

const CreatorLogo: React.FC<CreatorLogoProps> = ({ link = '' }) => {
    const isLinked: boolean = useMemo(
        () => (link?.length ? true : false),
        [link],
    );

    return (
        <Styled.Wrapper
            data-testid="CreatorLogo-wrapper"
            display="flex"
            justifyContent="center"
            alignItems="center"
            isLinked={isLinked}
        >
            {isLinked ? (
                <>
                    <Link
                        data-testid="CreatorLogo-link"
                        to={link}
                        onClick={() => {
                            window.scrollTo(0, 0);
                        }}
                    >
                        <HeadphonesOutlined size="lg" color="primary.500" />
                    </Link>
                </>
            ) : (
                <HeadphonesOutlined size="lg" color="primary.500" />
            )}
        </Styled.Wrapper>
    );
};

export default CreatorLogo;
